import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { useNavigate } from "react-router-dom";

import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { createClient } from "store/actions";
import ImageUpdate from "components/shared/ImageUpdate";

const AddSocial = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedImage, setSelectedImage] = useState({
    preview: "",
    path: "",
  });

  const { handleSubmit } = useForm();

  const onSubmit = (data) => {
    data.image = selectedImage.path;

    dispatch(
      createClient({
        data,
        navigate,
        toast,
      })
    );
  };

  return (
    <>
      <div className="acc-form">
        <div className="card card-client">
          <div className="card-head">
            <h4>اضافة عميل جديد</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>صورة العميل</h5>
                      <ImageUpdate
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                      />
                      {!selectedImage.path && (
                        <p className="error-hint">يرجي اختيار صورة العميل</p>
                      )}
                    </div>
                  </Col>
                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        اضافة
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSocial;
